module.exports = __webpack_public_path__ + "img/2022_jeep-compass.9173df68.png";